<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
const goToFeedback = (item) => {
  router.push({
    path: '/feedback',
  });
};
</script>

<template>
  <div class="entrance-box">
    <button class="feedback" @click="goToFeedback">我要反馈</button>
  </div>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
.entrance-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  background: #fff;
  width: 100%;
  height: 141 * $px;
  position: fixed; /* 设置entrance-box为绝对定位 */
  bottom: 0; /* 将entrance-box固定在底部 */

  .feedback {
    background: rgba(231, 235, 255, 1);
    color: rgba(75, 106, 255, 1);
    font-size: 32 * $px;
    line-height: 44.8 * $px;
    border: none;
    border-radius: 60 * $px;
    width: 625 * $px;
    height: 93 * $px;
  }
}
</style>
